<div class="bg-m0 flex-grow select-none flex-col overflow-y-auto p-9">
  <div
    data-cy="addEvDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Add Variable</div
  >

  <form
    class="flex w-[700px] flex-col"
    [formGroup]="addEvForm"
    (ngSubmit)="add()"
  >
    <input
      autocomplete="off"
      spellcheck="false"
      data-cy="addEvDialogEvIdInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          addEvForm.controls['evId'].invalid &&
          addEvForm.controls['evId'].touched
      }"
      formControlName="evId"
      placeholder="Name"
    />
    <m-validation [control]="addEvForm.controls['evId']"></m-validation>

    <input
      autocomplete="off"
      spellcheck="false"
      data-cy="addEvDialogValInput"
      class="form-input border-s3 focus:border-m600 mt-1 rounded"
      [ngClass]="{
        'border-r600':
          addEvForm.controls['val'].invalid && addEvForm.controls['val'].touched
      }"
      formControlName="val"
      placeholder="Value"
    />
    <m-validation [control]="addEvForm.controls['val']"></m-validation>

    <div class="mt-6">
      <button
        data-cy="addEvDialogAddButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Add</button
      >

      <button
        data-cy="addEvDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
